import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorBoundary, Provider } from '@rollbar/react';
import { CenteredLayout, DesignProvider, DigitalStoreI18Provider, LocaleProvider, StoreProvider, ThankYou, } from '@systemeio/digital-store-shared';
import { Toast } from '@systemeio/ui';
import React from 'react';
import { rollbarConfig } from '../rollbar';
export function ThankYouApp({ pageWithProviders }) {
    const { locale, design, ...page } = pageWithProviders;
    return (_jsx(React.StrictMode, { children: _jsx(StoreProvider, { initProps: {
                base: { locale },
            }, children: _jsx(Provider, { config: rollbarConfig, children: _jsx(ErrorBoundary, { children: _jsx(DigitalStoreI18Provider, { locale: locale, children: _jsx(LocaleProvider, { locale: locale, children: _jsxs(DesignProvider, { design: design, children: [_jsx(CenteredLayout, { children: _jsx(ThankYou, { ...page }) }), _jsx(Toast, {})] }) }) }) }) }) }) }));
}
